import { MissingChecklistsState } from '@infield/providers/checklist-scheduler-provider/types';
import type { TranslationFunctionType } from '@infield/utils/translation-utils/types';

export const getIsChecklistSchedulerBusy = (
  missingChecklistsState: MissingChecklistsState
): boolean => {
  return [
    MissingChecklistsState.SEARCHING_MISSING_CHECKLISTS,
    MissingChecklistsState.CREATING_CHECKLISTS,
  ].includes(missingChecklistsState);
};

/**
 * Get the tooltip content for the "missing checklsits button" based on the missing checklists state.
 * @param {MissingChecklistsState} missingChecklistsState - The current state of missing checklists.
 * @param {TranslationFunctionType} t - The translation function.
 * @returns {string | undefined} - The tooltip content or undefined if no tooltip is needed.
 */
export const getTooltipContent = (
  missingChecklistsState: MissingChecklistsState,
  t: TranslationFunctionType
): string | undefined => {
  switch (missingChecklistsState) {
    case MissingChecklistsState.SEARCHING_MISSING_CHECKLISTS:
      return t(
        'CHECKLIST_SCHEDULER_SEARCHING_MISSING_CHECKLISTS_TOOLTIP',
        'Searching for checklists, please wait...'
      );
    case MissingChecklistsState.CREATING_CHECKLISTS:
      return t(
        'CHECKLIST_SCHEDULER_CREATING_CHECKLISTS_TOOLTIP',
        'Creating checklists, please wait...'
      );
    default:
      return undefined;
  }
};
